export enum Country {
  AF = 'AF',
  AL = 'AL',
  DZ = 'DZ',
  AS = 'AS',
  AD = 'AD',
  AO = 'AO',
  AI = 'AI',
  AQ = 'AQ',
  AG = 'AG',
  AR = 'AR',
  AM = 'AM',
  AW = 'AW',
  AU = 'AU',
  AT = 'AT',
  AZ = 'AZ',
  BS = 'BS',
  BH = 'BH',
  BD = 'BD',
  BB = 'BB',
  BY = 'BY',
  BE = 'BE',
  BZ = 'BZ',
  BJ = 'BJ',
  BM = 'BM',
  BT = 'BT',
  BO = 'BO',
  BA = 'BA',
  BW = 'BW',
  BV = 'BV',
  BR = 'BR',
  IO = 'IO',
  BN = 'BN',
  BG = 'BG',
  BF = 'BF',
  BI = 'BI',
  KH = 'KH',
  CM = 'CM',
  CA = 'CA',
  CV = 'CV',
  KY = 'KY',
  CF = 'CF',
  TD = 'TD',
  CL = 'CL',
  CN = 'CN',
  CX = 'CX',
  CC = 'CC',
  CO = 'CO',
  KM = 'KM',
  CG = 'CG',
  CD = 'CD',
  CK = 'CK',
  CR = 'CR',
  CI = 'CI',
  HR = 'HR',
  CU = 'CU',
  CY = 'CY',
  CZ = 'CZ',
  DK = 'DK',
  DJ = 'DJ',
  DM = 'DM',
  DO = 'DO',
  EC = 'EC',
  EG = 'EG',
  SV = 'SV',
  GQ = 'GQ',
  ER = 'ER',
  EE = 'EE',
  ET = 'ET',
  FK = 'FK',
  FO = 'FO',
  FJ = 'FJ',
  FI = 'FI',
  FR = 'FR',
  GF = 'GF',
  PF = 'PF',
  TF = 'TF',
  GA = 'GA',
  GM = 'GM',
  GE = 'GE',
  DE = 'DE',
  GH = 'GH',
  GI = 'GI',
  GR = 'GR',
  GL = 'GL',
  GD = 'GD',
  GP = 'GP',
  GU = 'GU',
  GT = 'GT',
  GN = 'GN',
  GW = 'GW',
  GY = 'GY',
  HT = 'HT',
  HM = 'HM',
  VA = 'VA',
  HN = 'HN',
  HK = 'HK',
  HU = 'HU',
  IS = 'IS',
  IN = 'IN',
  ID = 'ID',
  IR = 'IR',
  IQ = 'IQ',
  IE = 'IE',
  IL = 'IL',
  IT = 'IT',
  JM = 'JM',
  JP = 'JP',
  JO = 'JO',
  KZ = 'KZ',
  KE = 'KE',
  KI = 'KI',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KG = 'KG',
  LA = 'LA',
  LV = 'LV',
  LB = 'LB',
  LS = 'LS',
  LR = 'LR',
  LY = 'LY',
  LI = 'LI',
  LT = 'LT',
  LU = 'LU',
  MO = 'MO',
  MG = 'MG',
  MW = 'MW',
  MY = 'MY',
  MV = 'MV',
  ML = 'ML',
  MT = 'MT',
  MH = 'MH',
  MQ = 'MQ',
  MR = 'MR',
  MU = 'MU',
  YT = 'YT',
  MX = 'MX',
  FM = 'FM',
  MD = 'MD',
  MC = 'MC',
  MN = 'MN',
  MS = 'MS',
  MA = 'MA',
  MZ = 'MZ',
  MM = 'MM',
  NA = 'NA',
  NR = 'NR',
  NP = 'NP',
  NL = 'NL',
  NC = 'NC',
  NZ = 'NZ',
  NI = 'NI',
  NE = 'NE',
  NG = 'NG',
  NU = 'NU',
  NF = 'NF',
  MP = 'MP',
  MK = 'MK',
  NO = 'NO',
  OM = 'OM',
  PK = 'PK',
  PW = 'PW',
  PS = 'PS',
  PA = 'PA',
  PG = 'PG',
  PY = 'PY',
  PE = 'PE',
  PH = 'PH',
  PN = 'PN',
  PL = 'PL',
  PT = 'PT',
  PR = 'PR',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RU = 'RU',
  RW = 'RW',
  SH = 'SH',
  KN = 'KN',
  LC = 'LC',
  PM = 'PM',
  VC = 'VC',
  WS = 'WS',
  SM = 'SM',
  ST = 'ST',
  SA = 'SA',
  SN = 'SN',
  SC = 'SC',
  SL = 'SL',
  SG = 'SG',
  SK = 'SK',
  SI = 'SI',
  SB = 'SB',
  SO = 'SO',
  ZA = 'ZA',
  GS = 'GS',
  ES = 'ES',
  LK = 'LK',
  SD = 'SD',
  SR = 'SR',
  SJ = 'SJ',
  SZ = 'SZ',
  SE = 'SE',
  CH = 'CH',
  SY = 'SY',
  TW = 'TW',
  TJ = 'TJ',
  TZ = 'TZ',
  TH = 'TH',
  TL = 'TL',
  TG = 'TG',
  TK = 'TK',
  TO = 'TO',
  TT = 'TT',
  TN = 'TN',
  TR = 'TR',
  TM = 'TM',
  TC = 'TC',
  TV = 'TV',
  UG = 'UG',
  UA = 'UA',
  AE = 'AE',
  GB = 'GB',
  US = 'US',
  UM = 'UM',
  UY = 'UY',
  UZ = 'UZ',
  VU = 'VU',
  VE = 'VE',
  VN = 'VN',
  VG = 'VG',
  VI = 'VI',
  WF = 'WF',
  EH = 'EH',
  YE = 'YE',
  ZM = 'ZM',
  ZW = 'ZW',
  AX = 'AX',
  BQ = 'BQ',
  CW = 'CW',
  GG = 'GG',
  IM = 'IM',
  JE = 'JE',
  ME = 'ME',
  BL = 'BL',
  MF = 'MF',
  RS = 'RS',
  SX = 'SX',
  SS = 'SS',
  XK = 'XK',
}

export const countryNames = {
  [Country.AF]: {fr: 'Afghanistan', en: 'Afghanistan'},
  [Country.AL]: {fr: 'Albanie', en: 'Albania'},
  [Country.DZ]: {fr: 'Algérie', en: 'Algeria'},
  [Country.AS]: {fr: 'Samoa américaines', en: 'American Samoa'},
  [Country.AD]: {fr: 'Andorre', en: 'Andorra'},
  [Country.AO]: {fr: 'Angola', en: 'Angola'},
  [Country.AI]: {fr: 'Anguilla', en: 'Anguilla'},
  [Country.AQ]: {fr: 'Antarctique', en: 'Antarctica'},
  [Country.AG]: {fr: 'Antigua-et-Barbuda', en: 'Antigua and Barbuda'},
  [Country.AR]: {fr: 'Argentine', en: 'Argentina'},
  [Country.AM]: {fr: 'Arménie', en: 'Armenia'},
  [Country.AW]: {fr: 'Aruba', en: 'Aruba'},
  [Country.AU]: {fr: 'Australie', en: 'Australia'},
  [Country.AT]: {fr: 'Autriche', en: 'Austria'},
  [Country.AZ]: {fr: 'Azerbaïdjan', en: 'Azerbaijan'},
  [Country.BS]: {fr: 'Bahamas', en: 'Bahamas'},
  [Country.BH]: {fr: 'Bahreïn', en: 'Bahrain'},
  [Country.BD]: {fr: 'Bangladesh', en: 'Bangladesh'},
  [Country.BB]: {fr: 'Barbade', en: 'Barbados'},
  [Country.BY]: {fr: 'Biélorussie', en: 'Belarus'},
  [Country.BE]: {fr: 'Belgique', en: 'Belgium'},
  [Country.BZ]: {fr: 'Belize', en: 'Belize'},
  [Country.BJ]: {fr: 'Bénin', en: 'Benin'},
  [Country.BM]: {fr: 'Bermudes', en: 'Bermuda'},
  [Country.BT]: {fr: 'Bhoutan', en: 'Bhutan'},
  [Country.BO]: {fr: 'Bolivie', en: 'Bolivia'},
  [Country.BA]: {fr: 'Bosnie-Herz', en: 'Bosnia and Herz'},
  [Country.BW]: {fr: 'Botswana', en: 'Botswana'},
  [Country.BV]: {fr: 'Île Bouvet', en: 'Bouvet Island'},
  [Country.BR]: {fr: 'Brésil', en: 'Brazil'},
  [Country.IO]: {fr: 'Territoire britannique de l’océan Indien', en: 'British Indian Ocean Territory'},
  [Country.BN]: {fr: 'Brunei', en: 'Brunei'},
  [Country.BG]: {fr: 'Bulgarie', en: 'Bulgaria'},
  [Country.BF]: {fr: 'Burkina Faso', en: 'Burkina Faso'},
  [Country.BI]: {fr: 'Burundi', en: 'Burundi'},
  [Country.KH]: {fr: 'Cambodge', en: 'Cambodia'},
  [Country.CM]: {fr: 'Cameroun', en: 'Cameroon'},
  [Country.CA]: {fr: 'Canada', en: 'Canada'},
  [Country.CV]: {fr: 'Cap-Vert', en: 'Cape Verde'},
  [Country.KY]: {fr: 'Îles Caïmans', en: 'Cayman Islands'},
  [Country.CF]: {fr: 'République centrafricaine', en: 'Central African Republic'},
  [Country.TD]: {fr: 'Tchad', en: 'Chad'},
  [Country.CL]: {fr: 'Chili', en: 'Chile'},
  [Country.CN]: {fr: 'Chine', en: 'China'},
  [Country.CX]: {fr: 'Île Christmas', en: 'Christmas Island'},
  [Country.CC]: {fr: 'Îles Cocos', en: 'Cocos Islands'},
  [Country.CO]: {fr: 'Colombie', en: 'Colombia'},
  [Country.KM]: {fr: 'Comores', en: 'Comoros'},
  [Country.CG]: {fr: 'République du Congo', en: 'Republic of the Congo'},
  [Country.CD]: {fr: 'République démocratique du Congo', en: 'Democratic Republic of the Congo'},
  [Country.CK]: {fr: 'Îles Cook', en: 'Cook Islands'},
  [Country.CR]: {fr: 'Costa Rica', en: 'Costa Rica'},
  [Country.CI]: {fr: 'Côte d’Ivoire', en: 'Côte d’Ivoire'},
  [Country.HR]: {fr: 'Croatie', en: 'Croatia'},
  [Country.CU]: {fr: 'Cuba', en: 'Cuba'},
  [Country.CY]: {fr: 'Chypre', en: 'Cyprus'},
  [Country.CZ]: {fr: 'République tchèque', en: 'Czech Republic'},
  [Country.DK]: {fr: 'Danemark', en: 'Denmark'},
  [Country.DJ]: {fr: 'Djibouti', en: 'Djibouti'},
  [Country.DM]: {fr: 'Dominique', en: 'Dominica'},
  [Country.DO]: {fr: 'République dominicaine', en: 'Dominican Republic'},
  [Country.EC]: {fr: 'Équateur', en: 'Ecuador'},
  [Country.EG]: {fr: 'Égypte', en: 'Egypt'},
  [Country.SV]: {fr: 'Salvador', en: 'El Salvador'},
  [Country.GQ]: {fr: 'Guinée équatoriale', en: 'Equatorial Guinea'},
  [Country.ER]: {fr: 'Érythrée', en: 'Eritrea'},
  [Country.EE]: {fr: 'Estonie', en: 'Estonia'},
  [Country.ET]: {fr: 'Éthiopie', en: 'Ethiopia'},
  [Country.FK]: {fr: 'Îles Malouines', en: 'Falkland Islands'},
  [Country.FO]: {fr: 'Îles Féroé', en: 'Faroe Islands'},
  [Country.FJ]: {fr: 'Fidji', en: 'Fiji'},
  [Country.FI]: {fr: 'Finlande', en: 'Finland'},
  [Country.FR]: {fr: 'France', en: 'France'},
  [Country.GF]: {fr: 'Guyane française', en: 'French Guiana'},
  [Country.PF]: {fr: 'Polynésie française', en: 'French Polynesia'},
  [Country.TF]: {fr: 'Terres australes françaises', en: 'French Southern Territories'},
  [Country.GA]: {fr: 'Gabon', en: 'Gabon'},
  [Country.GM]: {fr: 'Gambie', en: 'Gambia'},
  [Country.GE]: {fr: 'Géorgie', en: 'Georgia'},
  [Country.DE]: {fr: 'Allemagne', en: 'Germany'},
  [Country.GH]: {fr: 'Ghana', en: 'Ghana'},
  [Country.GI]: {fr: 'Gibraltar', en: 'Gibraltar'},
  [Country.GR]: {fr: 'Grèce', en: 'Greece'},
  [Country.GL]: {fr: 'Groenland', en: 'Greenland'},
  [Country.GD]: {fr: 'Grenade', en: 'Grenada'},
  [Country.GP]: {fr: 'Guadeloupe', en: 'Guadeloupe'},
  [Country.GU]: {fr: 'Guam', en: 'Guam'},
  [Country.GT]: {fr: 'Guatemala', en: 'Guatemala'},
  [Country.GN]: {fr: 'Guinée', en: 'Guinea'},
  [Country.GW]: {fr: 'Guinée-Bissau', en: 'Guinea-Bissau'},
  [Country.GY]: {fr: 'Guyana', en: 'Guyana'},
  [Country.HT]: {fr: 'Haïti', en: 'Haiti'},
  [Country.HM]: {fr: 'Îles Heard et McDonald', en: 'Heard Island and McDonald Islands'},
  [Country.VA]: {fr: 'Saint-Siège', en: 'Holy See'},
  [Country.HN]: {fr: 'Honduras', en: 'Honduras'},
  [Country.HK]: {fr: 'Hong Kong', en: 'Hong Kong'},
  [Country.HU]: {fr: 'Hongrie', en: 'Hungary'},
  [Country.IS]: {fr: 'Islande', en: 'Iceland'},
  [Country.IN]: {fr: 'Inde', en: 'India'},
  [Country.ID]: {fr: 'Indonésie', en: 'Indonesia'},
  [Country.IR]: {fr: 'Iran', en: 'Iran'},
  [Country.IQ]: {fr: 'Irak', en: 'Iraq'},
  [Country.IE]: {fr: 'Irlande', en: 'Ireland'},
  [Country.IL]: {fr: 'Israël', en: 'Israel'},
  [Country.IT]: {fr: 'Italie', en: 'Italy'},
  [Country.JM]: {fr: 'Jamaïque', en: 'Jamaica'},
  [Country.JP]: {fr: 'Japon', en: 'Japan'},
  [Country.JO]: {fr: 'Jordanie', en: 'Jordan'},
  [Country.KZ]: {fr: 'Kazakhstan', en: 'Kazakhstan'},
  [Country.KE]: {fr: 'Kenya', en: 'Kenya'},
  [Country.KI]: {fr: 'Kiribati', en: 'Kiribati'},
  [Country.KP]: {fr: 'Corée du Nord', en: 'North Korea'},
  [Country.KR]: {fr: 'Corée du Sud', en: 'South Korea'},
  [Country.KW]: {fr: 'Koweït', en: 'Kuwait'},
  [Country.KG]: {fr: 'Kirghizistan', en: 'Kyrgyzstan'},
  [Country.LA]: {fr: 'Laos', en: 'Laos'},
  [Country.LV]: {fr: 'Lettonie', en: 'Latvia'},
  [Country.LB]: {fr: 'Liban', en: 'Lebanon'},
  [Country.LS]: {fr: 'Lesotho', en: 'Lesotho'},
  [Country.LR]: {fr: 'Libéria', en: 'Liberia'},
  [Country.LY]: {fr: 'Libye', en: 'Libya'},
  [Country.LI]: {fr: 'Liechtenstein', en: 'Liechtenstein'},
  [Country.LT]: {fr: 'Lituanie', en: 'Lithuania'},
  [Country.LU]: {fr: 'Luxembourg', en: 'Luxembourg'},
  [Country.MO]: {fr: 'Macao', en: 'Macao'},
  [Country.MG]: {fr: 'Madagascar', en: 'Madagascar'},
  [Country.MW]: {fr: 'Malawi', en: 'Malawi'},
  [Country.MY]: {fr: 'Malaisie', en: 'Malaysia'},
  [Country.MV]: {fr: 'Maldives', en: 'Maldives'},
  [Country.ML]: {fr: 'Mali', en: 'Mali'},
  [Country.MT]: {fr: 'Malte', en: 'Malta'},
  [Country.MH]: {fr: 'Îles Marshall', en: 'Marshall Islands'},
  [Country.MQ]: {fr: 'Martinique', en: 'Martinique'},
  [Country.MR]: {fr: 'Mauritanie', en: 'Mauritania'},
  [Country.MU]: {fr: 'Maurice', en: 'Mauritius'},
  [Country.YT]: {fr: 'Mayotte', en: 'Mayotte'},
  [Country.MX]: {fr: 'Mexique', en: 'Mexico'},
  [Country.FM]: {fr: 'Micronésie', en: 'Micronesia'},
  [Country.MD]: {fr: 'Moldavie', en: 'Moldova'},
  [Country.MC]: {fr: 'Monaco', en: 'Monaco'},
  [Country.MN]: {fr: 'Mongolie', en: 'Mongolia'},
  [Country.MS]: {fr: 'Montserrat', en: 'Montserrat'},
  [Country.MA]: {fr: 'Maroc', en: 'Morocco'},
  [Country.MZ]: {fr: 'Mozambique', en: 'Mozambique'},
  [Country.MM]: {fr: 'Myanmar', en: 'Myanmar'},
  [Country.NA]: {fr: 'Namibie', en: 'Namibia'},
  [Country.NR]: {fr: 'Nauru', en: 'Nauru'},
  [Country.NP]: {fr: 'Népal', en: 'Nepal'},
  [Country.NL]: {fr: 'Pays-Bas', en: 'Netherlands'},
  [Country.NC]: {fr: 'Nouvelle-Calédonie', en: 'New Caledonia'},
  [Country.NZ]: {fr: 'Nouvelle-Zélande', en: 'New Zealand'},
  [Country.NI]: {fr: 'Nicaragua', en: 'Nicaragua'},
  [Country.NE]: {fr: 'Niger', en: 'Niger'},
  [Country.NG]: {fr: 'Nigéria', en: 'Nigeria'},
  [Country.NU]: {fr: 'Niue', en: 'Niue'},
  [Country.NF]: {fr: 'Île Norfolk', en: 'Norfolk Island'},
  [Country.MP]: {fr: 'Îles Mariannes du Nord', en: 'Northern Mariana Islands'},
  [Country.MK]: {fr: 'Macédoine', en: 'North Macedonia'},
  [Country.NO]: {fr: 'Norvège', en: 'Norway'},
  [Country.OM]: {fr: 'Oman', en: 'Oman'},
  [Country.PK]: {fr: 'Pakistan', en: 'Pakistan'},
  [Country.PW]: {fr: 'Palaos', en: 'Palau'},
  [Country.PS]: {fr: 'Palestine', en: 'Palestinian Territory'},
  [Country.PA]: {fr: 'Panama', en: 'Panama'},
  [Country.PG]: {fr: 'Papouasie-Nouvelle-Guinée', en: 'Papua New Guinea'},
  [Country.PY]: {fr: 'Paraguay', en: 'Paraguay'},
  [Country.PE]: {fr: 'Pérou', en: 'Peru'},
  [Country.PH]: {fr: 'Philippines', en: 'Philippines'},
  [Country.PN]: {fr: 'Îles Pitcairn', en: 'Pitcairn Islands'},
  [Country.PL]: {fr: 'Pologne', en: 'Poland'},
  [Country.PT]: {fr: 'Portugal', en: 'Portugal'},
  [Country.PR]: {fr: 'Porto Rico', en: 'Puerto Rico'},
  [Country.QA]: {fr: 'Qatar', en: 'Qatar'},
  [Country.RE]: {fr: 'Réunion', en: 'Réunion'},
  [Country.RO]: {fr: 'Roumanie', en: 'Romania'},
  [Country.RU]: {fr: 'Russie', en: 'Russia'},
  [Country.RW]: {fr: 'Rwanda', en: 'Rwanda'},
  [Country.SH]: {fr: 'Sainte-Hélène', en: 'Saint Helena'},
  [Country.KN]: {fr: 'Saint-Christophe-et-Niévès', en: 'Saint Kitts and Nevis'},
  [Country.LC]: {fr: 'Sainte-Lucie', en: 'Saint Lucia'},
  [Country.PM]: {fr: 'Saint-Pierre-et-Miquelon', en: 'Saint Pierre and Miquelon'},
  [Country.VC]: {fr: 'Saint-Vincent-et-les-Grenadines', en: 'Saint Vincent and the Grenadines'},
  [Country.WS]: {fr: 'Samoa', en: 'Samoa'},
  [Country.SM]: {fr: 'Saint-Marin', en: 'San Marino'},
  [Country.ST]: {fr: 'Sao Tomé-et-Principe', en: 'Sao Tome and Principe'},
  [Country.SA]: {fr: 'Arabie saoudite', en: 'Saudi Arabia'},
  [Country.SN]: {fr: 'Sénégal', en: 'Senegal'},
  [Country.SC]: {fr: 'Seychelles', en: 'Seychelles'},
  [Country.SL]: {fr: 'Sierra Leone', en: 'Sierra Leone'},
  [Country.SG]: {fr: 'Singapour', en: 'Singapore'},
  [Country.SK]: {fr: 'Slovaquie', en: 'Slovakia'},
  [Country.SI]: {fr: 'Slovénie', en: 'Slovenia'},
  [Country.SB]: {fr: 'Îles Salomon', en: 'Solomon Islands'},
  [Country.SO]: {fr: 'Somalie', en: 'Somalia'},
  [Country.ZA]: {fr: 'Afrique du Sud', en: 'South Africa'},
  [Country.GS]: {
    fr: 'Géorgie du Sud et les îles Sandwich du Sud',
    en: 'South Georgia and the South Sandwich Islands',
  },
  [Country.ES]: {fr: 'Espagne', en: 'Spain'},
  [Country.LK]: {fr: 'Sri Lanka', en: 'Sri Lanka'},
  [Country.SD]: {fr: 'Soudan', en: 'Sudan'},
  [Country.SR]: {fr: 'Suriname', en: 'Suriname'},
  [Country.SJ]: {fr: 'Svalbard et Jan Mayen', en: 'Svalbard and Jan Mayen'},
  [Country.SZ]: {fr: 'Eswatini', en: 'Eswatini'},
  [Country.SE]: {fr: 'Suède', en: 'Sweden'},
  [Country.CH]: {fr: 'Suisse', en: 'Switzerland'},
  [Country.SY]: {fr: 'Syrie', en: 'Syria'},
  [Country.TW]: {fr: 'Taïwan', en: 'Taiwan'},
  [Country.TJ]: {fr: 'Tadjikistan', en: 'Tajikistan'},
  [Country.TZ]: {fr: 'Tanzanie', en: 'Tanzania'},
  [Country.TH]: {fr: 'Thaïlande', en: 'Thailand'},
  [Country.TL]: {fr: 'Timor-Leste', en: 'Timor-Leste'},
  [Country.TG]: {fr: 'Togo', en: 'Togo'},
  [Country.TK]: {fr: 'Tokelau', en: 'Tokelau'},
  [Country.TO]: {fr: 'Tonga', en: 'Tonga'},
  [Country.TT]: {fr: 'Trinité-et-Tobago', en: 'Trinidad and Tobago'},
  [Country.TN]: {fr: 'Tunisie', en: 'Tunisia'},
  [Country.TR]: {fr: 'Turquie', en: 'Turkey'},
  [Country.TM]: {fr: 'Turkménistan', en: 'Turkmenistan'},
  [Country.TC]: {fr: 'Îles Turques-et-Caïques', en: 'Turks and Caicos Islands'},
  [Country.TV]: {fr: 'Tuvalu', en: 'Tuvalu'},
  [Country.UG]: {fr: 'Ouganda', en: 'Uganda'},
  [Country.UA]: {fr: 'Ukraine', en: 'Ukraine'},
  [Country.AE]: {fr: 'Émirats arabes unis', en: 'United Arab Emirates'},
  [Country.GB]: {fr: 'Royaume-Uni', en: 'United Kingdom'},
  [Country.US]: {fr: 'États-Unis', en: 'United States'},
  [Country.UM]: {fr: 'Îles mineures éloignées des États-Unis', en: 'United States Minor Outlying Islands'},
  [Country.UY]: {fr: 'Uruguay', en: 'Uruguay'},
  [Country.UZ]: {fr: 'Ouzbékistan', en: 'Uzbekistan'},
  [Country.VU]: {fr: 'Vanuatu', en: 'Vanuatu'},
  [Country.VE]: {fr: 'Venezuela', en: 'Venezuela'},
  [Country.VN]: {fr: 'Vietnam', en: 'Vietnam'},
  [Country.VG]: {fr: 'Îles Vierges britanniques', en: 'British Virgin Islands'},
  [Country.VI]: {fr: 'Îles Vierges américaines', en: 'U.S. Virgin Islands'},
  [Country.WF]: {fr: 'Wallis-et-Futuna', en: 'Wallis and Futuna'},
  [Country.EH]: {fr: 'Sahara occidental', en: 'Western Sahara'},
  [Country.YE]: {fr: 'Yémen', en: 'Yemen'},
  [Country.ZM]: {fr: 'Zambie', en: 'Zambia'},
  [Country.ZW]: {fr: 'Zimbabwe', en: 'Zimbabwe'},
  [Country.AX]: {fr: 'Îles Åland', en: 'Åland Islands'},
  [Country.BQ]: {fr: 'Pays-Bas caribéens', en: 'Caribbean Netherlands'},
  [Country.CW]: {fr: 'Curaçao', en: 'Curaçao'},
  [Country.GG]: {fr: 'Guernesey', en: 'Guernsey'},
  [Country.IM]: {fr: 'Île de Man', en: 'Isle of Man'},
  [Country.JE]: {fr: 'Jersey', en: 'Jersey'},
  [Country.ME]: {fr: 'Monténégro', en: 'Montenegro'},
  [Country.BL]: {fr: 'Saint-Barthélemy', en: 'Saint Barthélemy'},
  [Country.MF]: {fr: 'Saint-Martin', en: 'Saint Martin'},
  [Country.RS]: {fr: 'Serbie', en: 'Serbia'},
  [Country.SX]: {fr: 'Saint-Martin', en: 'Sint Maarten'},
  [Country.SS]: {fr: 'Soudan du Sud', en: 'South Sudan'},
  [Country.XK]: {fr: 'Kosovo', en: 'Kosovo'},
};
